module.exports = __webpack_public_path__ + "media/img/pages/companies/postfinance-240161ace5064cad481150fe15fa7eb3.png";